module.exports = "img/feather-customised/cancel.23c2689.svg";